import {
  GET_ACTIVITY,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_ERROR,
  DELETE_ACTIVITY,
  DELETE_ACTIVITY_SUCCESS,
  DELETE_ACTIVITY_ERROR
} from "../actions";

const INIT_STATE = {
  activityId: null,
  activity: null,
  activityDetailsError: "",
  trashActivitySuccess: "",
  trashActivityError: "",
  recordList : null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACTIVITY:
      return {
        ...state,
        loading: true,
        activityId: action.payload.activityId,
        activityDetailsError: "",
      };
    case GET_ACTIVITY_SUCCESS:
      
      return {
        ...state,
        loading: false,
        activityDetailsError: "",
        activity: action.payload.activity
      };
    case GET_ACTIVITY_ERROR:
      return { ...state, loading: false, activityDetailsError: action.payload ? action.payload.message : "" };
    
    case DELETE_ACTIVITY:
      return {
        ...state,
        loading: true,
        activityId: action.payload.activityId,
        trashActivityError: "",
        trashActivitySuccess: "",
      };
    case DELETE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        trashActivitySuccess: action.payload ? action.payload.successMessage : "",
      };
    case DELETE_ACTIVITY_ERROR:
      return {
        ...state,
        loading: false,
        trashActivityError: action.payload ? action.payload.message : "",
      };
    default:
      return { ...state };
  }
};
